import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowSplitRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-split-right, rules, direction, split"} maskId="square-filled-radius-0-stroke-1-IconArrowSplitRight"><path d="M21 10H20V4.70703L12.707 12L20 19.293V14H21V21H14V20H19.293L11.793 12.5H3V11.5H11.793L19.293 4H14V3H21V10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowSplitRight;
